module.exports = __webpack_public_path__ + "static/media/postgre.ecc8c7a6.png";